module.exports = __webpack_public_path__ + "img/SEJ enventos_fecha.5b10fc2e.svg";